import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-auto bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto pt-36 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p
            style={{ fontFamily: "'Orbitron', sans-serif" }}
            className="text-4xl font-bold inline border-b-4 border-gray-500"
          >
            About
          </p>
        </div>

        <p
          style={{ fontFamily: "sans-serif" }}
          className="text-2xl mt-9 tracking-wide leading-relaxed"
        >
          My journey into technology began with curiosity and has evolved into a
          dedicated pursuit of innovation. Over the past year, I've served as a
          blockchain and data security expert at a technology research company,
          while also mastering AI and ML through self-directed learning.
        </p>

        <br />

        <p
          style={{ fontFamily: "sans-serif" }}
          className="text-2xl tracking-wide leading-relaxed"
        >
          I have deep expertise in AI and ML, having developed predictive
          models, sophisticated AI applications, and advanced machine learning
          techniques. I'm passionate about using these skills to drive
          innovation and tackle complex challenges.
        </p>

        <br />

        <p
          style={{ fontFamily: "sans-serif" }}
          className="text-2xl tracking-wide leading-relaxed"
        >
          I'm currently seeking an AI/ML Expert position where I can apply my
          knowledge to make a meaningful impact. I'm open to job opportunities,
          collaborations, or inquiries. You can connect with me via Email or
          LinkedIn.
        </p>
      </div>
    </div>
  );
};

export default About;




